import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const FilterSection = styled(Flex)`
  display: flex;
  align-items: center;
  height: 48px; // Increased to match SearchSection
  min-width: fit-content;
  margin: 0;
  padding: 0;
  flex: 0.25;
  position: relative;
  margin-bottom: -12px; // Remove gap with table
`
export const FilterButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 48px;
  padding: 9px 22px;
  gap: 10px;
  border: none;
  border-top: 1px solid ${COLORS.GREY_T_90};
  border-bottom: 1px solid ${COLORS.GREY_T_90};

  border-radius: 0;
  background: ${COLORS.WHITE};
  color: ${COLORS.TEXT_HIGH};
  cursor: pointer;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  
  &:hover {
    background: ${COLORS.GREY_T_96};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`

export const FilterContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const FilterPopup = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 400px;
  background: ${COLORS.WHITE};
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
  border-radius: 0 0 8px 8px;
  z-index: 1000;
  max-height: calc(100vh - 200px);
  overflow-y: auto;
`
